import type { LucideIcon } from "lucide-react-native";
import {
  RefreshCw,
  Shuffle,
  CircleOff,
  MinusCircle,
  Shield,
  Droplet,
  Droplets,
  CloudRain,
  Zap,
  HeartCrack,
  Lock,
  Waves,
  MoreHorizontal,
} from "lucide-react-native";

export type CycleStatus =
  | "regular_cycle"
  | "irregular_cycle"
  | "no_longer_have_period"
  | "never_had_period"
  | "no_period_due_to_contraception";

export type FlowIntensity = "light" | "medium" | "heavy";

export type SymptomType =
  | "cramping"
  | "pelvic_pain"
  | "constipation"
  | "diarrhea"
  | "other";

export const CYCLE_STATUS_OPTIONS: {
  id: CycleStatus;
  labelKey: string;
  icon: LucideIcon;
}[] = [
  {
    id: "regular_cycle",
    labelKey: "med_history.gynae.menstrual_health.cycle_status.regular_cycle",
    icon: RefreshCw,
  },
  {
    id: "irregular_cycle",
    labelKey: "med_history.gynae.menstrual_health.cycle_status.irregular_cycle",
    icon: Shuffle,
  },
  {
    id: "no_longer_have_period",
    labelKey:
      "med_history.gynae.menstrual_health.cycle_status.no_longer_have_period",
    icon: CircleOff,
  },
  {
    id: "never_had_period",
    labelKey:
      "med_history.gynae.menstrual_health.cycle_status.never_had_period",
    icon: MinusCircle,
  },
  {
    id: "no_period_due_to_contraception",
    labelKey:
      "med_history.gynae.menstrual_health.cycle_status.no_period_due_to_contraception",
    icon: Shield,
  },
];

export const FLOW_INTENSITY_OPTIONS: {
  id: FlowIntensity;
  labelKey: string;
  icon: LucideIcon;
}[] = [
  {
    id: "light",
    labelKey: "med_history.gynae.menstrual_health.flow_intensity.light",
    icon: Droplet,
  },
  {
    id: "medium",
    labelKey: "med_history.gynae.menstrual_health.flow_intensity.medium",
    icon: Droplets,
  },
  {
    id: "heavy",
    labelKey: "med_history.gynae.menstrual_health.flow_intensity.heavy",
    icon: CloudRain,
  },
];

export const SYMPTOM_OPTIONS: {
  id: SymptomType;
  labelKey: string;
  icon: LucideIcon;
}[] = [
  {
    id: "cramping",
    labelKey: "med_history.gynae.menstrual_health.symptoms.cramping",
    icon: Zap,
  },
  {
    id: "pelvic_pain",
    labelKey: "med_history.gynae.menstrual_health.symptoms.pelvic_pain",
    icon: HeartCrack,
  },
  {
    id: "constipation",
    labelKey: "med_history.gynae.menstrual_health.symptoms.constipation",
    icon: Lock,
  },
  {
    id: "diarrhea",
    labelKey: "med_history.gynae.menstrual_health.symptoms.diarrhea",
    icon: Waves,
  },
  {
    id: "other",
    labelKey: "med_history.gynae.menstrual_health.symptoms.other",
    icon: MoreHorizontal,
  },
];
